import { ISharedDirectory } from '@fluidframework/map';
import { ITEMS_TREE_KEY, ITEM_LABELS_KEY, MfsItemId } from '../..';
import { assertPrecondition, mfsError, Result } from '../../errors';
import { assert, logVerbose } from '../../log';

/** Number of max keys an app can save in the root directory. */
export const MAX_ROOT_KEYS = 10;

const ulidRegex = /^[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{26}$/;

function canSetKey(root: ISharedDirectory, key: string): Result {
  // can reset already existing key
  if (root.has(key)) {
    return Result.ok();
  }
  let count = 0;
  const keysInUse = [];
  for (const keyInUse of root.keys()) {
    if (keyInUse !== ITEM_LABELS_KEY && keyInUse !== ITEMS_TREE_KEY) {
      keysInUse.push(keyInUse);
      ++count;
      if (count === MAX_ROOT_KEYS) {
        return Result.fail(mfsError.maxBootKeys(MAX_ROOT_KEYS, keysInUse));
      }
    }
  }
  return Result.ok();
}

/** Sets the given app key - value in `root` directory. */
export function setRootKey(root: ISharedDirectory, key: string, value: MfsItemId): void {
  assertPrecondition(ulidRegex.test(value), () => mfsError.invalidBootValue());
  assert(() => canSetKey(root, key));
  root.set(key, value);
  logVerbose('setRootKey', `set boot item, value ${value}`);
}

/** Gets the given app key from `root` directory. */
export function getRootKey(root: ISharedDirectory, key: string): MfsItemId | undefined {
  const value = root.get<MfsItemId>(key);
  logVerbose('getRootKey', `boot item ${value === undefined ? 'not found.' : 'found, value:'} ${value ?? ''}`);
  return value;
}

/** Deletes the given app key from `root` directory. */
export function deleteRootKey(root: ISharedDirectory, key: string): void {
  if (!root.has(key)) {
    logVerbose('deleteRootKey', 'boot item not found');
    return;
  }
  root.delete(key);
  logVerbose('deleteRootKey', `deleted boot item`);
}
